<template>
  <el-dialog
    v-if="visible"
    :title="title"
    :close-on-click-modal="false"
    :visible.sync="visible"
    append-to-body
    class="staff-dialog"
    width="840px"
  >
    <el-form label-position="left" :model="dataForm" :rules="dataRule" class="data-form" ref="dataForm">
      <el-row>
        <el-col :span="12">
          <!-- 姓名 -->
          <el-form-item :label="isCreate ? $t('i18n.1647917071064') : $t('22')">
            <template v-if="isCreate">
              <staff-search
                ref="staffSearch"
                comment="comment"
                :formal-state="true"
                @change="handleStaffChange"
                :dataPrivilege="1"
              />
            </template>
            <template v-else>
              {{ dataForm.staff_name || '--' }}
            </template>
          </el-form-item>
          <template v-if="isSelected">
            <!-- 部门 -->
            <el-form-item :label="$t('27')">{{ dataForm.department_name || '--' }}</el-form-item>
            <!-- 员工状态 -->
            <el-form-item :label="$t('31')">{{ dataForm.state_txt || '--' }}</el-form-item>
            <!-- 试用期(天) -->
            <el-form-item :label="$t('invite_7')">
              <el-input
                v-model.number="dataForm.probation_day"
                @input="dataForm.probation_day = String(dataForm.probation_day).replace(/[^\d]/g, '')"
                @blur="onProbationDay(dataForm.probation_day)"
                :placeholder="$t('90')"
              />
            </el-form-item>
            <!-- 试用期评估状态 -->
            <el-form-item prop="evaluate_state" v-if="['handle', 'create'].includes(operateType)">
              <template slot="label">
                <span>{{ $t('invite_45') }} </span>
                <el-tooltip class="item" effect="dark" :content="$t('invite_8')" placement="top-start">
                  <div slot="content">
                    <p>{{ $t('invite_46') }}</p>
                    <p>{{ $t('invite_47') }}</p>
                    <p>{{ $t('invite_48') }}</p>
                  </div>
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </template>
              <el-select v-model="dataForm.evaluate_state" :placeholder="$t('221')" @change="update_period_status">
                <el-option
                  v-for="(item, key, index) in sysInfoArr.staff_evaluate_state"
                  :disabled="evaluateDisabled[index]"
                  :key="key"
                  :label="item"
                  :value="key"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('invite_45')" v-else> {{ dataForm.evaluate_state_txt }}</el-form-item>
          </template>
        </el-col>
        <el-col v-if="isSelected" :span="12">
          <!-- 工号 -->
          <el-form-item :label="$t('25')" prop="staff_code">{{ dataForm.staff_code || '--' }}</el-form-item>
          <!-- 职位 -->
          <el-form-item :label="$t('24')" prop="job_title_id">{{ dataForm.job_title_name || '--' }}</el-form-item>
          <!-- 选择入职时间 -->
          <el-form-item :label="$t('28')">{{ dataForm.hire_date || '--' }}</el-form-item>
          <!-- 转正日期 -->
          <el-form-item prop="formal_date" :label="$t('30')">
            <el-date-picker
              v-model="dataForm.formal_date"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('792')"
              :picker-options="pickerOptions"
              @change="handleDatePickerChange"
            />
          </el-form-item>
          <!-- 试用期状态 -->
          <el-form-item :label="$t('invite_13')">{{ dataForm.formal_state_txt }}</el-form-item>
        </el-col>
      </el-row>
      <template v-if="isSelected">
        <!-- 备注 -->
        <el-col :span="24">
          <el-form-item :label="$t('1602')">
            <el-input
              type="textarea"
              :placeholder="$t('1602')"
              v-model="dataForm.remark"
              maxlength="1000"
              class="textarea"
              :rows="6"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <!-- 附件 -->
        <el-col :span="24">
          <el-form-item :label="$t('attachment')">
            <div style="display: flex">
              <Upload
                ref="upload"
                listType="picture"
                :file-limit="limit"
                :file-format="fileFormat"
                :show-btn="true"
                :show-file="true"
                @success="uploadInfo => uploadSuccess(uploadInfo)"
              />
              <div style="margin-left: 15px; color: #909399">{{ $t('upload_tips') }}</div>
            </div>
          </el-form-item>
        </el-col>
      </template>
    </el-form>
    <template slot="footer">
      <el-button v-if="operateType === 'edit'" type="danger" class="danger" @click="onCancel">{{
        $t('invite_51')
      }}</el-button>
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="dataFormSubmit"> {{ $t('131') }} </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { baseHeaders } from 'util/axios-request'
import { addStaffRegular, editStaffRegular, cancelStaffRegular } from '@/api/org/per'
import Upload from '_c/upload'
import StaffSearch from '_c/staff-search'
import { getRegularEnv } from 'api/dashboard'

const baseURL = process.env.VUE_APP_BASE_API
const dataForm = () => ({
  probation_day: '',
  evaluate_state: '1',
  formal_date: '',
  remark: '', // 备注
  attachment: []
})

export default {
  components: { Upload, StaffSearch },
  props: {
    sysInfoArr: {
      type: Object,
      default: () => ({
        state: [] // 在职状态
      })
    }
  },
  data() {
    const slef = this
    return {
      visible: false,
      disabled: false,
      operateType: '',
      dataForm: dataForm(),
      limit: 5,
      fileFormat: ['.png', '.jpg', '.jpeg', '.xls', '.xlsx', '.doc', '.docx', '.pdf'],
      uploadUrl: baseURL + '/web/tool/upload_file',
      baseHeaders: baseHeaders(),
      initFiles: [],
      dataRule: {
        hire_date: [{ required: true, message: this.$t('795') }],
        formal_date: [{ required: true, message: this.$t('800') }],
        evaluate_state: [{ required: true, message: this.$t('800') }]
      },
      evaluateDisabled: [],
      pickerOptions: {
        disabledDate: time => {
          // 离职日期在hire_date之后可以选择
          const hire_date = new Date(slef.dataForm.hire_date).getTime() - 86400000
          return time.getTime() < hire_date
        }
      }
    }
  },
  computed: {
    isCreate() {
      return this.operateType === 'create'
    },
    isSelected() {
      if (this.operateType !== 'create') return true
      if (!this.dataForm.staff_name) return false
      return true
    },
    title() {
      const titles = {
        handle: this.$t('invite_49'),
        edit: this.$t('invite_50'),
        create: this.$t('i18n.1647916135444')
      }
      return titles[this.operateType]
    }
  },
  methods: {
    init(item, type) {
      this.visible = true
      this.operateType = type
      this.dataForm = item ? JSON.parse(JSON.stringify(Object.assign(this.dataForm, item))) : dataForm()
      const evaluateKey = Object.keys(this.sysInfoArr.staff_evaluate_state)
      this.evaluateDisabled = []
      // “评估通过”或“评估不通过”可改为“评估不通过”或“评估通过”，不可改为“待评估”
      evaluateKey.forEach(key => {
        this.evaluateDisabled.push(key === '1' && ['2', '3'].includes(this.dataForm.evaluate_state))
      })
      this.$nextTick(() => {
        if (!this.$refs.upload) return
        this.$refs.upload.successFileList = this.dataForm.attachment
      })
    },
    disabledDate(t) {
      // 离职日期在hire_date之后可以选择
      return new Date().getTime() < t.getTime()
    },
    onProbationDay(v) {
      // 填写了“试用期(天)”，自动计算：转正日期=入职日期+试用期(天)——入职日期为第0天
      if (!String(v)) return
      const day = Number(v)
      const hireData = new Date(this.dataForm.hire_date)
      hireData.setDate(hireData.getDate() + day)
      this.dataForm.formal_date = this.formatDay(hireData)
    },
    // 时间戳转换为日期 2020-09-08
    formatDay(timestamp) {
      var date = new Date(timestamp)
      var YY = date.getFullYear()
      var MM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return `${YY}-${MM}-${DD}`
    },
    uploadSuccess(val) {
      this.dataForm.attachment = val || []
    },
    onCancel() {
      // 撤销转正
      this.$alert(`<p> ${this.$t('invite_52')} </p><p> ${this.$t('invite_53')} </p>`, this.$t('invite_51'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          cancelStaffRegular({ staff_id: this.dataForm.staff_id }).then(res => {
            if (res && res.code === 1) {
              this.visible = false
              this.$message.success(res.message)
              this.$emit('refreshTableList')
            }
          })
        })
        .catch(() => {})
    },
    dataFormSubmit() {
      if (!this.isSelected) {
        this.$message.error(this.$t('i18n.1647917583450'))
        return
      }
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.disabled = true
          const query = {
            staff_id: this.dataForm.staff_id,
            remark: this.dataForm.remark,
            probation_day: this.dataForm.probation_day,
            formal_date: this.dataForm.formal_date,
            attachment: this.dataForm.attachment.length
              ? this.dataForm.attachment
              : [{ file_name: '', object_key: '', object_url: '' }]
          }
          if (['handle', 'create'].includes(this.operateType)) query.state = this.dataForm.evaluate_state
          this.ajaxFn(query)
            .then(res => {
              if (res && res.code === 1) {
                this.visible = false
                this.$message.success(res.message)
                this.$emit('refreshTableList')
              }
            })
            .catch(() => {})
            .finally(() => (this.disabled = false))
        }
      })
    },
    ajaxFn(data) {
      return this.operateType === 'edit' ? editStaffRegular(data) : addStaffRegular(data)
    },
    handleStaffChange(v) {
      this.dataForm = dataForm()
      if (!v.staff_id) return
      this.$http({
        url: '/web/staff/view',
        data: { staff_id: v.staff_id }
      }).then(async res => {
        this.dataForm = JSON.parse(JSON.stringify(Object.assign(this.dataForm, res.data)))
        this.dataForm.state_txt = this.dataForm.state_name
        if (!this.dataForm.probation_day || this.dataForm.probation_day === '0') {
          const res = await getRegularEnv({ code: 'STAFF_PROBATION_DAY' })
          if (res && res.code) {
            this.dataForm.probation_day = res.data
          }
        }
        if (!this.dataForm.formal_date) {
          this.onProbationDay(this.dataForm.probation_day)
        }
        if (!this.dataForm.formal_state_txt) {
          this.update_period_status(this.dataForm.evaluate_state)
        }
      })
    },
    // 根据转正日期、试用期评估联动更新状态
    update_period_status(value) {
      const v = +value
      const statusMap = new Map([
        [1, this.$t('invite_30')],
        [2, this.$t('invite_31')],
        [3, this.$t('invite_32')]
      ])
      if (v === 2) {
        if (!this.dataForm.formal_date) {
          this.dataForm.formal_state_txt = ''
          return
        }
        const formal_date = parseInt(this.dataForm.formal_date.replace(/-/g, ''))
        const nowDate = parseInt(this.$util.fmtDate('yyyy-MM-dd').replace(/-/g, ''))
        if (formal_date > nowDate) {
          this.dataForm.formal_state_txt = statusMap.get(1)
        } else {
          this.dataForm.formal_state_txt = statusMap.get(2)
        }
      } else {
        this.dataForm.formal_state_txt = statusMap.get(v)
      }
    },
    handleDatePickerChange() {
      if (+this.dataForm.evaluate_state === 2) {
        this.update_period_status(this.dataForm.evaluate_state)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
/deep/ .el-input {
  width: 100%;
  min-width: 100%;
}
.danger {
  background: #fff;
  color: #f56c6c;
  float: left;
}
.data-form {
  .el-col {
    padding: 0 20px;
    /deep/ .el-form-item {
      .el-form-item__label {
        float: none;
        height: 36px;
        display: block;
        &::before {
          left: -10px;
        }
      }
      .el-form-item__content,
      .el-select,
      .el-date-editor {
        width: 100%;
      }
      .el-input {
        max-width: 90%;
      }
    }
  }
}
</style>
